import NotificationsArchiveActionControllerBase from "./notifications-archive-action-controller-base";

export default class extends NotificationsArchiveActionControllerBase {
  connect() {
    App.Helpers.listenToCustomEvent(document, "archive-one-notification:complete", this.hideActivity.bind(this));
  }

  hideActivity(event) {
    if (this.element === event.detail.el) App.Helpers.fadeOut(this.activityEl);
  }

  get completeEventName() {
    return `archive-one-notification${this.isIndex ? "-in-index" : ""}:complete`;
  }

  get activityEl() {
    return this.element.closest(".activity");
  }

  get isIndex() {
    return !!this.data.get("in-index");
  }
};



// WEBPACK FOOTER //
// ./app/components/notifications/assets/javascript/notifications-archive-one-link-controller.js